import * as React from "react";

import "./options-step.scss";

import {enableCanadaMailing} from "@Common/logic/enable-canada-mailing";
import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {fragments}           from "@Common/react/fragments";
import {Invoke}              from "@Common/react/invoke";
import {UseState}            from "@Common/react/use-state";
import {ItemOptions}         from "@Common/ui-components/heavy/item-options/item-options";
import {parseUrlQuery}       from "@Common/utils/parse-url-query";

import {SampleMailingCard} from "../../../common/heavy/sample-mailing-card/sample-mailing-card";
import {loadMailingLists}  from "../common/load-mailing-lists";

import {CartSummaryTable}           from "./cart-summary-table";
import {LoadItem}                   from "./minors/load-item";
import {LoadLayout}                 from "./minors/load-layout";
import {loadTemplateOptions}        from "./minors/load-template-options";
import {RedirectedFromPHP}          from "./minors/redirected-from-php";
import {distributionOptionsModules} from "./modules/distribution-options-modules";
import {ProceedButton}              from "./proceed-button";
import {ProductOptionsSection}      from "./product-options-section/product-options-section";

export const OptionsStep = ({match, location}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("company"),
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["itemId", (_, next) => next(match.params.item_id)],
    ["item", ({itemId}, next) => LoadItem({itemId, next})],
    ({itemId, apis}, next) => fragments(
        next(),
        itemId && Invoke({
            action: async () => {
                await apis.next.mailing.getCassByItemId({itemId});
            },
        })
    ),
    ["templateOptions", ({item}, next) => loadTemplateOptions({sku: item.sku, next})],
    ({item, query, templateOptions}, next) => RedirectedFromPHP({item,templateOptions, query, next}),
    ({item, company}, next) => LoadLayout({item, company, next}),
    ({}, next) => (
        <div className="options-step-42s">
            {next()}
        </div>
    ),
    ["mailingLists", ({}, next) => loadMailingLists({next})],
    ["canadaMailing", ({templateOptions}, next) => enableCanadaMailing({templateOptions, next})],
    ["itemOptions", ({session, templateOptions, item, mailingLists, canadaMailing}, next) => ItemOptions({
        templateOptions,
        item,
        extraModules: [
            ...distributionOptionsModules({agent: session?.data?.agent, item, templateOptions, mailingLists: mailingLists.value, canadaMailing}),
        ],
        next,
    })],
    ["isNDM", ({item}, next) => next(
        !!(item?.metaData?.template?.isNDM)
    )],
    ["showErrors", (_, next) => UseState({next})],
    ({itemOptions, showErrors, query, item, isNDM}) => <>
        <div className="main">
            {itemOptions.ui.deliveryMethod}

            {itemOptions.ui.pickupAddress?.({
                className: "section",
            })}

            {itemOptions.ui.topControl?.({
                showErrors: showErrors.value,
            })}

            {itemOptions.ui["informedDelivery"]?.({
                showErrors: showErrors.value,
            })}

            {itemOptions.ui.downloadDelivery?.({
                showErrors: showErrors.value,
            })}

            {itemOptions.ui.sampleMailingCard && SampleMailingCard({
                ...itemOptions.ui.sampleMailingCard,
            })}

            {itemOptions.ui.futureFulfillment?.({
                showErrors: showErrors.value,
            })}

            {itemOptions.ui.bulkMailPermit}

            {itemOptions.ui.imb}

            {ProductOptionsSection({
                showErrors: showErrors.value,
                itemOptionsStates: itemOptions.ui,
            })}
        </div>

        {/*{isDevQuan() && OnUnmounted({*/}
        {/*    action: () => console.log("[ERROR 124823] Unmounted"),*/}
        {/*})}*/}

        <div className="summary">
            <div className="sticky">
                <div className="box">

                    {/*{isDevQuan() && (*/}
                    {/*    <pre>{JSON.stringify(omit(itemOptions.directs, ["paperType"]), null, 4)}</pre>*/}
                    {/*)}*/}
                    {/*{isDevQuan() && (*/}
                    {/*    <pre>{JSON.stringify(itemOptions.getSummary(), null, 4)}</pre>*/}
                    {/*)}*/}

                    {CartSummaryTable({
                        summary: itemOptions.summary,
                        isNDM
                    })}

                    <div className="actions">
                        {ProceedButton({
                            itemOptions, showErrors, query, item,
                        })}
                    </div>
                </div>
            </div>
        </div>
    </>,
);

